import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "./GameRoomBackButton.css";

export default function GameRoomBackButton({
  className = "",
  standalone = false,
}) {
  const navigate = useNavigate();

  const classes = [
    "game-room-back",
    standalone ? "game-room-back--standalone" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type="button"
      className={classes}
      onClick={() => navigate("/games")}
      aria-label="Back to Game Room"
    >
      <FaArrowLeft aria-hidden="true" />
      <span>Game Room</span>
    </button>
  );
}
